export default __webpack_public_path__ + "static/media/sanitize.4a2f87ff.jpg";